import _ from "lodash";

class ZString {

  /**
   * 
   * @param  {...String} strings 
   */
  static containsOneEmpty(...strings){
    return _.some(strings, o => _.isEmpty(o));
  }

  /**
   * 
   * @param {String} str 
   * @param {Number} length 
   * @param {String} subsitute 
   * @param {"start" | "end"} direction 
   */
  static Hide(str, length, subsitute = "*", direction = "start"){
    if(direction === "start"){
      let regex = new RegExp(String.raw`(?<=^.{0,${length - 1}}).`, "g");
      return str.replace(regex, subsitute);
    }else{
      let regex = new RegExp(String.raw`.{${length}}$`, "g");
      return str.replace(regex, _.map(_.range(0, length), o => subsitute).join(""));
    }
  }

  static RemoveHtmlTags(html) {
    var div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  }

  static ExtractAllStringsFromObj(obj, rtn = []){
    if(_.isObject(obj)){
      _.map(obj, (o, i) => {
        this.ExtractAllStringsFromObj(o, rtn);
      });
    }else if(_.isArray(obj)){
      _.map(obj, (o, i) => {
        this.ExtractAllStringsFromObj(o, rtn);
      });
    }else if(_.isString(obj)){
      rtn.push(obj);
    }

    return rtn;
  }

  static SearchText(text, searchText){
    if(_.isEmpty(searchText)){
      return true;
    }

    if(_.isEmpty(text)){
      return false;
    }

    let texts = this.ExtractAllStringsFromObj(text);

    texts = _.map(texts, o => o.toLowerCase());
    searchText = searchText.toLowerCase();

    if(_.some(texts, o => o.includes(searchText))){
      return true;
    }

    return false;
  }


  static isOnlyEnglish(str){
    return /^[a-zA-Z0-9\s]+$/.test(str);
  }

  static containsChinese(str){
    return /[\u4e00-\u9fa5]/.test(str);
  }

  static LastToken(str, delimiter = /\s+/){
    if(_.isEmpty(str)) return "";
    let tokens = str.split(delimiter);
    return tokens[tokens.length - 1];
  }

  static RemoveLastToken(str, delimiter = /\s+/){
    if(_.isEmpty(str)) return "";
    let tokens = str.split(delimiter);
    tokens.pop();
    return tokens.join(" ");
  }
  
}

export default ZString;